import * as React from "react"
import { cn } from "../../lib/utils"

const Card = React.forwardRef((props, ref) => {
  const { className, ...rest } = props
  return (
    <div
      ref={ref}
      className={cn(
        "rounded-2xl border border-border/70 bg-card text-card-foreground shadow-soft",
        className
      )}
      {...rest}
    />
  )
})
Card.displayName = "Card"

const CardHeader = React.forwardRef((props, ref) => {
  const { className, ...rest } = props
  return (
    <div ref={ref} className={cn("flex flex-col space-y-1.5 p-4 sm:p-5", className)} {...rest} />
  )
})
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef((props, ref) => {
  const { className, children, ...rest } = props
  return (
    <h3
      ref={ref}
      className={cn("text-lg font-bold leading-tight", className)}
      {...rest}
    >
      {children}
    </h3>
  )
})
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef((props, ref) => {
  const { className, ...rest } = props
  return (
    <p ref={ref} className={cn("text-sm text-muted-foreground", className)} {...rest} />
  )
})
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef((props, ref) => {
  const { className, ...rest } = props
  return <div ref={ref} className={cn("p-4 pt-0 sm:p-5 sm:pt-0", className)} {...rest} />
})
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef((props, ref) => {
  const { className, ...rest } = props
  return (
    <div ref={ref} className={cn("flex items-center p-4 pt-0 sm:p-5 sm:pt-0", className)} {...rest} />
  )
})
CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }



